// extracted by mini-css-extract-plugin
export default {"aboutContentContainer":"AboutContent_aboutContentContainer__D9pi2","btnView":"AboutContent_btnView__wFrcC"};